<template>
  <v-tooltip content-class="custom-tooltip" top>
    <v-btn
      slot="activator"
      :class="indicator"
      fab
      small
      class="fab-btn-xs alert-indicator"
      @click="$emit('click')"
    >
      {{ alertTag }}
    </v-btn>
    <span>{{ tip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    alertTag: String,
    tip: String,
    alert: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    indicator() {
      return this.alert ? "error blink" : "success";
    },
  },
};
</script>

<style scoped>
.alert-indicator {
  height: 17px;
  width: 17px;
  font-size: 12px;
  text-align: center;
}
</style>
